import React from 'react';
import TextField from '@material-ui/core/TextField';

const FormField = ({label, label_exclaim, name, error, touched, onChange, onBlur, autoComplete, ...props}) => (
    <TextField
        id={name}
        name={name}
        label={label}
        placeholder={label}
        onChange={onChange}
        onBlur={onBlur}
        error={touched && !!error}
        helperText={(touched && error) || label_exclaim}
        autoComplete={autoComplete ? autoComplete : 'off'}
        {...props}
    />
);

FormField.defaultProps = {
    fullWidth: true,
};

export default FormField;


// WEBPACK FOOTER //
// ./resources/assets/js/components/Form/FormField.js